__turbopack_context__.v({
  "container": "Spinner-module-scss-module__YgrEHa__container",
  "default-size": "Spinner-module-scss-module__YgrEHa__default-size",
  "rotate": "Spinner-module-scss-module__YgrEHa__rotate",
});
